import Swiper from 'swiper/bundle';

export const swipers = () => {

  

  const firstScreenSwiper = new Swiper('.firstScreenSwiper', {
    slidesPerView: 1,
    autoplay: {
        delay: 7000,
        disableOnInteraction: true
      },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    navigation: {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
    },
  });


  const abonimentsSwiper = new Swiper('.abonimentsSwiper', {
    slidesPerView: 1.1,
    spaceBetween: 16,
    autoplay: {
        delay: 7000,
        disableOnInteraction: true
    },
    navigation: {
      prevEl: ".myswiper__prev",
      nextEl: ".myswiper__next",
    },
    breakpoints: {
      390: {
        slidesPerView: 1.2,
      },
      991: {
        slidesPerView: 2.1,
      },
    }
  });

  const funSwiper = new Swiper('.funSwiper', {
    slidesPerView: 1.1,
    spaceBetween: 16,
    autoplay: {
        delay: 7000,
        disableOnInteraction: true
    },
    breakpoints: {
      390: {
        slidesPerView: 1.2,
      },
      991: {
        slidesPerView: 2.1,
      },
    }
  });

  const vipSwiper = new Swiper('.js-vip-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: {
        delay: 7000,
        disableOnInteraction: true
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next",
    },
    breakpoints: {
      /* 390: {
        slidesPerView: 1.2,
      },
      991: {
        slidesPerView: 2,
      }, */
    }
  });

  const moreSlider = document.querySelectorAll('.js-modal-more-slider')
  if (moreSlider.length > 0) {
    moreSlider.forEach(slider => {
      const moreSwiper = new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
            prevEl: ".myswiper__prev",
            nextEl: ".myswiper__next",
        }
      });    
    })
  }
}